import UnitsPage from './UnitsPage';

export default UnitsPage;
